var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignYield = function SvgSignYield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#sign_yield_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.265 15.58v1.92h-.99v-1.9L11.6 12.5h1.1l1.06 2.123h.04l1.07-2.123h1.07zm2.805-3.08v5h-.99v-5zm1.71 4.19h2.237v.81h-3.22v-5h3.22v.81H18.78v1.282h2.105v.758H18.78zm3.802-.033h2.12v.843h-3.11v-5h.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.01 17.5v-5h1.825c1.517 0 2.235.91 2.235 2.488 0 1.59-.727 2.512-2.238 2.512zm1.69-4.193H26v3.383h.7c.93 0 1.35-.555 1.35-1.685 0-1.125-.422-1.698-1.35-1.698",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.055 36.085a2.828 2.828 0 0 0 4.9 0L40.098 6.918c1.142-1.945-.23-4.418-2.45-4.418H3.36C1.137 2.5-.233 4.975.91 6.918zM20.505 35a.3.3 0 0 1-.16-.04.4.4 0 0 1-.135-.142L3.067 5.65a.45.45 0 0 1-.005-.458.5.5 0 0 1 .135-.15A.25.25 0 0 1 3.362 5h34.283a.3.3 0 0 1 .165.043.4.4 0 0 1 .137.15.45.45 0 0 1-.007.457L20.8 34.818a.4.4 0 0 1-.135.142.3.3 0 0 1-.157.04z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sign_yield_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h40v40H.5z"
  })))));
};
export default SvgSignYield;